/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Rental_List6Inputs */

const es_footer_link_rental_list6 = /** @type {(inputs: Footer_Link_Rental_List6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alquiler · Lista 6ª`)
};

const gl_footer_link_rental_list6 = /** @type {(inputs: Footer_Link_Rental_List6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alugueiro · Lista 6ª`)
};

const en_footer_link_rental_list6 = /** @type {(inputs: Footer_Link_Rental_List6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Rental · List 6`)
};

/**
* | output |
* | --- |
* | "Zarpar Rental · List 6" |
*
* @param {Footer_Link_Rental_List6Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_rental_list6 = /** @type {((inputs?: Footer_Link_Rental_List6Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Rental_List6Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_rental_list6(inputs)
	if (locale === "en") return en_footer_link_rental_list6(inputs)
	return es_footer_link_rental_list6(inputs)
});